import React from "react";
import { useTranslation } from "react-i18next";

function ApplePay(props) {
  const { i18n, t } = useTranslation();

  return (
    <div className="d-flex flex-column justify-content-center align-items-center w-100">
      <div class="apple-pay-button apple-pay-button-black w-75 my-3" lang={i18n.language} onClick={() => props.applePayHandler()}></div>
    </div>
  );
}

export default ApplePay;
